import { MenuProps } from 'antd'
import React from 'react'
import { IAccountByUser } from 'src/app/shared/models/accountSetup.model'
import { GetClientListPayload, IGetAccountListResponse } from 'src/app/shared/models/clientSetup.model'

export interface AccountByUserContextProps {
  uploadDropdownItems: MenuProps['items']
  isLoading: boolean
  accountByUser: IAccountByUser[]
  total: number
  getActionItems: (rowData: any) => MenuProps['items']
  handleSearch: (value: Partial<IGetAccountListResponse | GetClientListPayload>) => Promise<any>
}

export const AccountByUserContext = React.createContext<AccountByUserContextProps>({
  uploadDropdownItems: [],
  isLoading: false,
  accountByUser: [],
  total: 0,
  getActionItems: () => [],
  handleSearch: () => Promise.resolve({}),
})

export const useAccountByUserContext = () => React.useContext<AccountByUserContextProps>(AccountByUserContext)
